import React, { useEffect, useState } from 'react';

import { getUsers, IUser } from '~/src/dash/api/console-api';
import { MaterialSearchDropdownMulti } from '~/src/dash/components/material-search-dropdown-multi';
import { IListItem, IMenuList } from '~/src/dash/types/menuList';
import { obfuscateUserName } from '~/src/dash/utils/obfuscate';

// component handles the api call and generation of menu list for users
// on top of the MaterialSearchDropdownMulti
interface IProps {
  onChange: (userIDs: string[]) => void;
  publisherID: string;
  userIDs: string[];
  // default false
  disabled?: boolean;
  // default true
  enableMultiSelect?: boolean;
  maxHeight?: number;
  username: string;
}

export const UserMultiSelect = function ({
  onChange,
  disabled = false,
  userIDs = [],
  publisherID,
  enableMultiSelect = true,
  maxHeight,
  username,
}: IProps) {
  const [userMenuList, setUserMenuList] = useState<IMenuList>({});

  function handleMenuSelectionDone(values: IMenuList) {
    const userIDs = Object.values(values)
      .filter((src: IListItem) => {
        return src.selected;
      })
      .map((src: IListItem) => src.ID);
    onChange(userIDs);
  }

  useEffect(() => {
    getUsers({
      query: {
        publisher_id: publisherID,
      },
    })
      .then((resp) => {
        setUserMenuList(buildUserMenuList(resp.users, userIDs, username));
      })
      .catch(() => setUserMenuList({}));
  }, [publisherID]);

  return (
    <MaterialSearchDropdownMulti
      getValueFromSearchElement={(src: IListItem) => src.title}
      selectAll={enableMultiSelect}
      menuTitle='Users'
      list={userMenuList}
      disabled={disabled}
      onChange={setUserMenuList}
      handleMenuAcceptClick={handleMenuSelectionDone}
      isNoneSelectedAllSelected={false}
      enableMultiSelect={enableMultiSelect}
      width='400'
      maxHeight={maxHeight}
    />
  );
};

function buildUserMenuList(users: IUser[], selectedIDs: string[], username: string): IMenuList {
  const list = {} as IMenuList;

  users.forEach((user) => {
    list[user.ID] = {
      title: obfuscateUserName(user, username, `${user.FirstName} ${user.LastName}`),
      ID: user.ID.toString(),
      selected: selectedIDs.includes(user.ID),
    } as IListItem;
  });
  return list;
}
